@file:OptIn(InternalResourceApi::class)

package resursedeblocat.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/resursedeblocat.composeapp.generated.resources/"

@delegate:ResourceContentHash(-2_130_076_532)
internal val Res.string.about_author: StringResource by lazy {
      StringResource("string:about_author", "about_author", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 36),
      ))
    }

@delegate:ResourceContentHash(-1_406_329_766)
internal val Res.string.about_resource: StringResource by lazy {
      StringResource("string:about_resource", "about_resource", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47, 42),
      ))
    }

@delegate:ResourceContentHash(643_529_183)
internal val Res.string.access_resource: StringResource by lazy {
      StringResource("string:access_resource", "access_resource", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 90, 47),
      ))
    }

@delegate:ResourceContentHash(613_013_854)
internal val Res.string.admin_checkins_count: StringResource by lazy {
      StringResource("string:admin_checkins_count", "admin_checkins_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138, 52),
      ))
    }

@delegate:ResourceContentHash(-2_134_682_236)
internal val Res.string.admin_missing_answer: StringResource by lazy {
      StringResource("string:admin_missing_answer", "admin_missing_answer", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 191, 36),
      ))
    }

@delegate:ResourceContentHash(-904_331_478)
internal val Res.string.admin_no_checkins: StringResource by lazy {
      StringResource("string:admin_no_checkins", "admin_no_checkins", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 228, 89),
      ))
    }

@delegate:ResourceContentHash(1_542_623_344)
internal val Res.string.admin_no_email: StringResource by lazy {
      StringResource("string:admin_no_email", "admin_no_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 318, 54),
      ))
    }

@delegate:ResourceContentHash(-2_047_512_180)
internal val Res.string.admin_no_resources: StringResource by lazy {
      StringResource("string:admin_no_resources", "admin_no_resources", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 373, 90),
      ))
    }

@delegate:ResourceContentHash(311_207_538)
internal val Res.string.admin_resources_count: StringResource by lazy {
      StringResource("string:admin_resources_count", "admin_resources_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 464, 49),
      ))
    }

@delegate:ResourceContentHash(623_922_027)
internal val Res.string.admin_unknown_user: StringResource by lazy {
      StringResource("string:admin_unknown_user", "admin_unknown_user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 514, 58),
      ))
    }

@delegate:ResourceContentHash(-245_528_953)
internal val Res.string.admin_user_details: StringResource by lazy {
      StringResource("string:admin_user_details", "admin_user_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 573, 50),
      ))
    }

@delegate:ResourceContentHash(-801_020_005)
internal val Res.string.ai_analyzing: StringResource by lazy {
      StringResource("string:ai_analyzing", "ai_analyzing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 624, 80),
      ))
    }

@delegate:ResourceContentHash(-1_104_104_189)
internal val Res.string.ai_searching: StringResource by lazy {
      StringResource("string:ai_searching", "ai_searching", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 705, 88),
      ))
    }

@delegate:ResourceContentHash(656_716_145)
internal val Res.string.delete_resource: StringResource by lazy {
      StringResource("string:delete_resource", "delete_resource", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 794, 43),
      ))
    }

@delegate:ResourceContentHash(358_171_266)
internal val Res.string.done: StringResource by lazy {
      StringResource("string:done", "done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 838, 20),
      ))
    }

@delegate:ResourceContentHash(1_738_869_389)
internal val Res.string.error_login_cancelled: StringResource by lazy {
      StringResource("string:error_login_cancelled", "error_login_cancelled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 859, 73),
      ))
    }

@delegate:ResourceContentHash(-674_813_004)
internal val Res.string.error_login_generic: StringResource by lazy {
      StringResource("string:error_login_generic", "error_login_generic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 933, 119),
      ))
    }

@delegate:ResourceContentHash(-349_121_408)
internal val Res.string.find_new_resources: StringResource by lazy {
      StringResource("string:find_new_resources", "find_new_resources", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1053, 46),
      ))
    }

@delegate:ResourceContentHash(-201_664_053)
internal val Res.string.login_google: StringResource by lazy {
      StringResource("string:login_google", "login_google", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1100, 52),
      ))
    }

@delegate:ResourceContentHash(789_670_258)
internal val Res.string.logout: StringResource by lazy {
      StringResource("string:logout", "logout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1153, 30),
      ))
    }

@delegate:ResourceContentHash(-1_272_286_697)
internal val Res.string.month_1: StringResource by lazy {
      StringResource("string:month_1", "month_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1271, 27),
      ))
    }

@delegate:ResourceContentHash(1_223_226_962)
internal val Res.string.month_10: StringResource by lazy {
      StringResource("string:month_10", "month_10", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1184, 28),
      ))
    }

@delegate:ResourceContentHash(116_443_887)
internal val Res.string.month_11: StringResource by lazy {
      StringResource("string:month_11", "month_11", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1213, 28),
      ))
    }

@delegate:ResourceContentHash(273_821_192)
internal val Res.string.month_12: StringResource by lazy {
      StringResource("string:month_12", "month_12", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1242, 28),
      ))
    }

@delegate:ResourceContentHash(1_018_127_829)
internal val Res.string.month_2: StringResource by lazy {
      StringResource("string:month_2", "month_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1299, 27),
      ))
    }

@delegate:ResourceContentHash(-1_905_540_903)
internal val Res.string.month_3: StringResource by lazy {
      StringResource("string:month_3", "month_3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1327, 23),
      ))
    }

@delegate:ResourceContentHash(-691_765_629)
internal val Res.string.month_4: StringResource by lazy {
      StringResource("string:month_4", "month_4", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1351, 27),
      ))
    }

@delegate:ResourceContentHash(2_588_333)
internal val Res.string.month_5: StringResource by lazy {
      StringResource("string:month_5", "month_5", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1379, 19),
      ))
    }

@delegate:ResourceContentHash(1_988_417_314)
internal val Res.string.month_6: StringResource by lazy {
      StringResource("string:month_6", "month_6", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1399, 23),
      ))
    }

@delegate:ResourceContentHash(1_986_570_272)
internal val Res.string.month_7: StringResource by lazy {
      StringResource("string:month_7", "month_7", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1423, 23),
      ))
    }

@delegate:ResourceContentHash(-1_503_577_899)
internal val Res.string.month_8: StringResource by lazy {
      StringResource("string:month_8", "month_8", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1447, 23),
      ))
    }

@delegate:ResourceContentHash(453_295_505)
internal val Res.string.month_9: StringResource by lazy {
      StringResource("string:month_9", "month_9", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1471, 31),
      ))
    }

@delegate:ResourceContentHash(1_024_417_072)
internal val Res.string.monthly_tracking_title: StringResource by lazy {
      StringResource("string:monthly_tracking_title", "monthly_tracking_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1503, 62),
      ))
    }

@delegate:ResourceContentHash(1_490_329_836)
internal val Res.string.msg_abandoned: StringResource by lazy {
      StringResource("string:msg_abandoned", "msg_abandoned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1566, 77),
      ))
    }

@delegate:ResourceContentHash(-1_364_018_026)
internal val Res.string.msg_finished: StringResource by lazy {
      StringResource("string:msg_finished", "msg_finished", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1644, 76),
      ))
    }

@delegate:ResourceContentHash(-502_036_182)
internal val Res.string.msg_not_obtained: StringResource by lazy {
      StringResource("string:msg_not_obtained", "msg_not_obtained", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1721, 68),
      ))
    }

@delegate:ResourceContentHash(-1_676_802_307)
internal val Res.string.msg_obtained: StringResource by lazy {
      StringResource("string:msg_obtained", "msg_obtained", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1790, 96),
      ))
    }

@delegate:ResourceContentHash(-2_119_457_067)
internal val Res.string.my_resources: StringResource by lazy {
      StringResource("string:my_resources", "my_resources", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1887, 40),
      ))
    }

@delegate:ResourceContentHash(832_692_978)
internal val Res.string.no_resources: StringResource by lazy {
      StringResource("string:no_resources", "no_resources", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1928, 72),
      ))
    }

@delegate:ResourceContentHash(1_231_485_648)
internal val Res.string.no_trackings: StringResource by lazy {
      StringResource("string:no_trackings", "no_trackings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2001, 68),
      ))
    }

@delegate:ResourceContentHash(-327_646_723)
internal val Res.string.option_abandoned: StringResource by lazy {
      StringResource("string:option_abandoned", "option_abandoned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2070, 68),
      ))
    }

@delegate:ResourceContentHash(1_345_605_444)
internal val Res.string.option_finished: StringResource by lazy {
      StringResource("string:option_finished", "option_finished", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2139, 47),
      ))
    }

@delegate:ResourceContentHash(-1_684_733_333)
internal val Res.string.option_not_obtained: StringResource by lazy {
      StringResource("string:option_not_obtained", "option_not_obtained", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2187, 71),
      ))
    }

@delegate:ResourceContentHash(-1_469_585_618)
internal val Res.string.option_obtained: StringResource by lazy {
      StringResource("string:option_obtained", "option_obtained", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2259, 63),
      ))
    }

@delegate:ResourceContentHash(1_481_913_144)
internal val Res.string.other_categories: StringResource by lazy {
      StringResource("string:other_categories", "other_categories", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2323, 60),
      ))
    }

@delegate:ResourceContentHash(339_230_228)
internal val Res.string.personal_journey: StringResource by lazy {
      StringResource("string:personal_journey", "personal_journey", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2384, 52),
      ))
    }

@delegate:ResourceContentHash(-374_649_178)
internal val Res.string.recommend_if: StringResource by lazy {
      StringResource("string:recommend_if", "recommend_if", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2437, 40),
      ))
    }

@delegate:ResourceContentHash(-331_592_896)
internal val Res.string.search_back: StringResource by lazy {
      StringResource("string:search_back", "search_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2478, 31),
      ))
    }

@delegate:ResourceContentHash(713_820_753)
internal val Res.string.search_choose_category_subtitle: StringResource by lazy {
      StringResource("string:search_choose_category_subtitle", "search_choose_category_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2510, 159),
      ))
    }

@delegate:ResourceContentHash(1_602_298_162)
internal val Res.string.search_choose_category_title: StringResource by lazy {
      StringResource("string:search_choose_category_title", "search_choose_category_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2670, 60),
      ))
    }

@delegate:ResourceContentHash(-1_122_808_384)
internal val Res.string.search_choose_type_subtitle: StringResource by lazy {
      StringResource("string:search_choose_type_subtitle", "search_choose_type_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2731, 267),
      ))
    }

@delegate:ResourceContentHash(-774_146_468)
internal val Res.string.search_choose_type_title: StringResource by lazy {
      StringResource("string:search_choose_type_title", "search_choose_type_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2999, 80),
      ))
    }

@delegate:ResourceContentHash(-1_975_646_221)
internal val Res.string.search_context_hint: StringResource by lazy {
      StringResource("string:search_context_hint", "search_context_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3080, 175),
      ))
    }

@delegate:ResourceContentHash(-1_362_936_482)
internal val Res.string.search_context_placeholder: StringResource by lazy {
      StringResource("string:search_context_placeholder", "search_context_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3256, 226),
      ))
    }

@delegate:ResourceContentHash(1_656_976_932)
internal val Res.string.search_context_subtitle: StringResource by lazy {
      StringResource("string:search_context_subtitle", "search_context_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3483, 155),
      ))
    }

@delegate:ResourceContentHash(1_544_109_869)
internal val Res.string.search_context_title: StringResource by lazy {
      StringResource("string:search_context_title", "search_context_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3639, 80),
      ))
    }

@delegate:ResourceContentHash(26_435_792)
internal val Res.string.search_drag_handle_content_description: StringResource by lazy {
      StringResource("string:search_drag_handle_content_description", "search_drag_handle_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3720, 78),
      ))
    }

@delegate:ResourceContentHash(-1_879_502_925)
internal val Res.string.search_finish: StringResource by lazy {
      StringResource("string:search_finish", "search_finish", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3799, 37),
      ))
    }

@delegate:ResourceContentHash(-17_515_249)
internal val Res.string.search_next: StringResource by lazy {
      StringResource("string:search_next", "search_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3837, 31),
      ))
    }

@delegate:ResourceContentHash(1_300_496_356)
internal val Res.string.search_step_category: StringResource by lazy {
      StringResource("string:search_step_category", "search_step_category", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3869, 40),
      ))
    }

@delegate:ResourceContentHash(-2_128_799_077)
internal val Res.string.search_step_context: StringResource by lazy {
      StringResource("string:search_step_context", "search_step_context", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3910, 39),
      ))
    }

@delegate:ResourceContentHash(1_026_067_732)
internal val Res.string.search_step_type: StringResource by lazy {
      StringResource("string:search_step_type", "search_step_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3950, 40),
      ))
    }

@delegate:ResourceContentHash(-1_094_013_784)
internal val Res.string.state_abandoned: StringResource by lazy {
      StringResource("string:state_abandoned", "state_abandoned", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3991, 35),
      ))
    }

@delegate:ResourceContentHash(-2_089_364_419)
internal val Res.string.state_finished: StringResource by lazy {
      StringResource("string:state_finished", "state_finished", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4027, 34),
      ))
    }

@delegate:ResourceContentHash(-74_533_063)
internal val Res.string.state_in_progress: StringResource by lazy {
      StringResource("string:state_in_progress", "state_in_progress", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4062, 37),
      ))
    }

@delegate:ResourceContentHash(1_794_819_111)
internal val Res.string.tab_admin: StringResource by lazy {
      StringResource("string:tab_admin", "tab_admin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4100, 25),
      ))
    }

@delegate:ResourceContentHash(-186_203_241)
internal val Res.string.tab_resources: StringResource by lazy {
      StringResource("string:tab_resources", "tab_resources", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4126, 33),
      ))
    }

@delegate:ResourceContentHash(-1_952_281_346)
internal val Res.string.tab_tracking: StringResource by lazy {
      StringResource("string:tab_tracking", "tab_tracking", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4160, 32),
      ))
    }

@delegate:ResourceContentHash(-331_592_896)
internal val Res.string.track_back: StringResource by lazy {
      StringResource("string:track_back", "track_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4193, 30),
      ))
    }

@delegate:ResourceContentHash(-1_879_502_925)
internal val Res.string.track_finish: StringResource by lazy {
      StringResource("string:track_finish", "track_finish", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4224, 36),
      ))
    }

@delegate:ResourceContentHash(1_557_006_376)
internal val Res.string.track_last_month: StringResource by lazy {
      StringResource("string:track_last_month", "track_last_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4261, 68),
      ))
    }

@delegate:ResourceContentHash(-17_515_249)
internal val Res.string.track_next: StringResource by lazy {
      StringResource("string:track_next", "track_next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4330, 30),
      ))
    }

@delegate:ResourceContentHash(0)
internal val Res.string.tracking_add_entry_placeholder: StringResource by lazy {
      StringResource("string:tracking_add_entry_placeholder", "tracking_add_entry_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4361, 38),
      ))
    }

@delegate:ResourceContentHash(-794_922_616)
internal val Res.string.tracking_add_more: StringResource by lazy {
      StringResource("string:tracking_add_more", "tracking_add_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4400, 41),
      ))
    }

@delegate:ResourceContentHash(-648_587_565)
internal val Res.string.tracking_answer_placeholder: StringResource by lazy {
      StringResource("string:tracking_answer_placeholder", "tracking_answer_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4442, 75),
      ))
    }

@delegate:ResourceContentHash(1_216_816_547)
internal val Res.string.tracking_anything_else_subtitle: StringResource by lazy {
      StringResource("string:tracking_anything_else_subtitle", "tracking_anything_else_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4518, 99),
      ))
    }

@delegate:ResourceContentHash(-101_833_013)
internal val Res.string.tracking_anything_else_title: StringResource by lazy {
      StringResource("string:tracking_anything_else_title", "tracking_anything_else_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4618, 108),
      ))
    }

@delegate:ResourceContentHash(852_781_297)
internal val Res.string.tracking_deblocat_subtitle: StringResource by lazy {
      StringResource("string:tracking_deblocat_subtitle", "tracking_deblocat_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4727, 226),
      ))
    }

@delegate:ResourceContentHash(-871_540_958)
internal val Res.string.tracking_deblocat_title: StringResource by lazy {
      StringResource("string:tracking_deblocat_title", "tracking_deblocat_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4954, 55),
      ))
    }

@delegate:ResourceContentHash(-259_352_654)
internal val Res.string.tracking_delete_content_description: StringResource by lazy {
      StringResource("string:tracking_delete_content_description", "tracking_delete_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5010, 55),
      ))
    }

@delegate:ResourceContentHash(504_023_235)
internal val Res.string.tracking_energy_env_label: StringResource by lazy {
      StringResource("string:tracking_energy_env_label", "tracking_energy_env_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5066, 137),
      ))
    }

@delegate:ResourceContentHash(29_521_980)
internal val Res.string.tracking_energy_subtitle: StringResource by lazy {
      StringResource("string:tracking_energy_subtitle", "tracking_energy_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5204, 180),
      ))
    }

@delegate:ResourceContentHash(-1_760_991_608)
internal val Res.string.tracking_energy_title: StringResource by lazy {
      StringResource("string:tracking_energy_title", "tracking_energy_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5385, 53),
      ))
    }

@delegate:ResourceContentHash(1_965_861_079)
internal val Res.string.tracking_energy_work_label: StringResource by lazy {
      StringResource("string:tracking_energy_work_label", "tracking_energy_work_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5439, 106),
      ))
    }

@delegate:ResourceContentHash(-626_042_407)
internal val Res.string.tracking_example_label: StringResource by lazy {
      StringResource("string:tracking_example_label", "tracking_example_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5546, 42),
      ))
    }

@delegate:ResourceContentHash(0)
internal val Res.string.tracking_interaction_minigroup_subtitle: StringResource by lazy {
      StringResource("string:tracking_interaction_minigroup_subtitle", "tracking_interaction_minigroup_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5589, 47),
      ))
    }

@delegate:ResourceContentHash(1_528_135_785)
internal val Res.string.tracking_interaction_minigroup_title: StringResource by lazy {
      StringResource("string:tracking_interaction_minigroup_title", "tracking_interaction_minigroup_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5637, 100),
      ))
    }

@delegate:ResourceContentHash(0)
internal val Res.string.tracking_join_minigroup_subtitle: StringResource by lazy {
      StringResource("string:tracking_join_minigroup_subtitle", "tracking_join_minigroup_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5738, 40),
      ))
    }

@delegate:ResourceContentHash(52_156_901)
internal val Res.string.tracking_join_minigroup_title: StringResource by lazy {
      StringResource("string:tracking_join_minigroup_title", "tracking_join_minigroup_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5779, 105),
      ))
    }

@delegate:ResourceContentHash(2_610_850)
internal val Res.string.tracking_no: StringResource by lazy {
      StringResource("string:tracking_no", "tracking_no", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6104, 23),
      ))
    }

@delegate:ResourceContentHash(2_136_806_502)
internal val Res.string.tracking_not_well_being_subtitle: StringResource by lazy {
      StringResource("string:tracking_not_well_being_subtitle", "tracking_not_well_being_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5885, 128),
      ))
    }

@delegate:ResourceContentHash(-820_391_422)
internal val Res.string.tracking_not_well_being_title: StringResource by lazy {
      StringResource("string:tracking_not_well_being_title", "tracking_not_well_being_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6014, 89),
      ))
    }

@delegate:ResourceContentHash(0)
internal val Res.string.tracking_participated_minigroup_subtitle: StringResource by lazy {
      StringResource("string:tracking_participated_minigroup_subtitle", "tracking_participated_minigroup_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6128, 48),
      ))
    }

@delegate:ResourceContentHash(-2_003_688_782)
internal val Res.string.tracking_participated_minigroup_title: StringResource by lazy {
      StringResource("string:tracking_participated_minigroup_title", "tracking_participated_minigroup_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6177, 101),
      ))
    }

@delegate:ResourceContentHash(491_448_576)
internal val Res.string.tracking_practical_example1: StringResource by lazy {
      StringResource("string:tracking_practical_example1", "tracking_practical_example1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6279, 83),
      ))
    }

@delegate:ResourceContentHash(1_739_826_810)
internal val Res.string.tracking_practical_example2: StringResource by lazy {
      StringResource("string:tracking_practical_example2", "tracking_practical_example2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6363, 83),
      ))
    }

@delegate:ResourceContentHash(-1_552_272_824)
internal val Res.string.tracking_practical_example3: StringResource by lazy {
      StringResource("string:tracking_practical_example3", "tracking_practical_example3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6447, 79),
      ))
    }

@delegate:ResourceContentHash(-1_735_107_075)
internal val Res.string.tracking_practical_subtitle: StringResource by lazy {
      StringResource("string:tracking_practical_subtitle", "tracking_practical_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6527, 171),
      ))
    }

@delegate:ResourceContentHash(-1_524_481_428)
internal val Res.string.tracking_practical_title: StringResource by lazy {
      StringResource("string:tracking_practical_title", "tracking_practical_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6699, 56),
      ))
    }

@delegate:ResourceContentHash(1_381_010_909)
internal val Res.string.tracking_theory_example1: StringResource by lazy {
      StringResource("string:tracking_theory_example1", "tracking_theory_example1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6756, 64),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("about_author", Res.string.about_author)
  map.put("about_resource", Res.string.about_resource)
  map.put("access_resource", Res.string.access_resource)
  map.put("admin_checkins_count", Res.string.admin_checkins_count)
  map.put("admin_missing_answer", Res.string.admin_missing_answer)
  map.put("admin_no_checkins", Res.string.admin_no_checkins)
  map.put("admin_no_email", Res.string.admin_no_email)
  map.put("admin_no_resources", Res.string.admin_no_resources)
  map.put("admin_resources_count", Res.string.admin_resources_count)
  map.put("admin_unknown_user", Res.string.admin_unknown_user)
  map.put("admin_user_details", Res.string.admin_user_details)
  map.put("ai_analyzing", Res.string.ai_analyzing)
  map.put("ai_searching", Res.string.ai_searching)
  map.put("delete_resource", Res.string.delete_resource)
  map.put("done", Res.string.done)
  map.put("error_login_cancelled", Res.string.error_login_cancelled)
  map.put("error_login_generic", Res.string.error_login_generic)
  map.put("find_new_resources", Res.string.find_new_resources)
  map.put("login_google", Res.string.login_google)
  map.put("logout", Res.string.logout)
  map.put("month_1", Res.string.month_1)
  map.put("month_10", Res.string.month_10)
  map.put("month_11", Res.string.month_11)
  map.put("month_12", Res.string.month_12)
  map.put("month_2", Res.string.month_2)
  map.put("month_3", Res.string.month_3)
  map.put("month_4", Res.string.month_4)
  map.put("month_5", Res.string.month_5)
  map.put("month_6", Res.string.month_6)
  map.put("month_7", Res.string.month_7)
  map.put("month_8", Res.string.month_8)
  map.put("month_9", Res.string.month_9)
  map.put("monthly_tracking_title", Res.string.monthly_tracking_title)
  map.put("msg_abandoned", Res.string.msg_abandoned)
  map.put("msg_finished", Res.string.msg_finished)
  map.put("msg_not_obtained", Res.string.msg_not_obtained)
  map.put("msg_obtained", Res.string.msg_obtained)
  map.put("my_resources", Res.string.my_resources)
  map.put("no_resources", Res.string.no_resources)
  map.put("no_trackings", Res.string.no_trackings)
  map.put("option_abandoned", Res.string.option_abandoned)
  map.put("option_finished", Res.string.option_finished)
  map.put("option_not_obtained", Res.string.option_not_obtained)
  map.put("option_obtained", Res.string.option_obtained)
  map.put("other_categories", Res.string.other_categories)
  map.put("personal_journey", Res.string.personal_journey)
  map.put("recommend_if", Res.string.recommend_if)
  map.put("search_back", Res.string.search_back)
  map.put("search_choose_category_subtitle", Res.string.search_choose_category_subtitle)
  map.put("search_choose_category_title", Res.string.search_choose_category_title)
  map.put("search_choose_type_subtitle", Res.string.search_choose_type_subtitle)
  map.put("search_choose_type_title", Res.string.search_choose_type_title)
  map.put("search_context_hint", Res.string.search_context_hint)
  map.put("search_context_placeholder", Res.string.search_context_placeholder)
  map.put("search_context_subtitle", Res.string.search_context_subtitle)
  map.put("search_context_title", Res.string.search_context_title)
  map.put("search_drag_handle_content_description", Res.string.search_drag_handle_content_description)
  map.put("search_finish", Res.string.search_finish)
  map.put("search_next", Res.string.search_next)
  map.put("search_step_category", Res.string.search_step_category)
  map.put("search_step_context", Res.string.search_step_context)
  map.put("search_step_type", Res.string.search_step_type)
  map.put("state_abandoned", Res.string.state_abandoned)
  map.put("state_finished", Res.string.state_finished)
  map.put("state_in_progress", Res.string.state_in_progress)
  map.put("tab_admin", Res.string.tab_admin)
  map.put("tab_resources", Res.string.tab_resources)
  map.put("tab_tracking", Res.string.tab_tracking)
  map.put("track_back", Res.string.track_back)
  map.put("track_finish", Res.string.track_finish)
  map.put("track_last_month", Res.string.track_last_month)
  map.put("track_next", Res.string.track_next)
  map.put("tracking_add_entry_placeholder", Res.string.tracking_add_entry_placeholder)
  map.put("tracking_add_more", Res.string.tracking_add_more)
  map.put("tracking_answer_placeholder", Res.string.tracking_answer_placeholder)
  map.put("tracking_anything_else_subtitle", Res.string.tracking_anything_else_subtitle)
  map.put("tracking_anything_else_title", Res.string.tracking_anything_else_title)
  map.put("tracking_deblocat_subtitle", Res.string.tracking_deblocat_subtitle)
  map.put("tracking_deblocat_title", Res.string.tracking_deblocat_title)
  map.put("tracking_delete_content_description", Res.string.tracking_delete_content_description)
  map.put("tracking_energy_env_label", Res.string.tracking_energy_env_label)
  map.put("tracking_energy_subtitle", Res.string.tracking_energy_subtitle)
  map.put("tracking_energy_title", Res.string.tracking_energy_title)
  map.put("tracking_energy_work_label", Res.string.tracking_energy_work_label)
  map.put("tracking_example_label", Res.string.tracking_example_label)
  map.put("tracking_interaction_minigroup_subtitle", Res.string.tracking_interaction_minigroup_subtitle)
  map.put("tracking_interaction_minigroup_title", Res.string.tracking_interaction_minigroup_title)
  map.put("tracking_join_minigroup_subtitle", Res.string.tracking_join_minigroup_subtitle)
  map.put("tracking_join_minigroup_title", Res.string.tracking_join_minigroup_title)
  map.put("tracking_no", Res.string.tracking_no)
  map.put("tracking_not_well_being_subtitle", Res.string.tracking_not_well_being_subtitle)
  map.put("tracking_not_well_being_title", Res.string.tracking_not_well_being_title)
  map.put("tracking_participated_minigroup_subtitle", Res.string.tracking_participated_minigroup_subtitle)
  map.put("tracking_participated_minigroup_title", Res.string.tracking_participated_minigroup_title)
  map.put("tracking_practical_example1", Res.string.tracking_practical_example1)
  map.put("tracking_practical_example2", Res.string.tracking_practical_example2)
  map.put("tracking_practical_example3", Res.string.tracking_practical_example3)
  map.put("tracking_practical_subtitle", Res.string.tracking_practical_subtitle)
  map.put("tracking_practical_title", Res.string.tracking_practical_title)
  map.put("tracking_theory_example1", Res.string.tracking_theory_example1)
}
